import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../../constants/actionTypes";
import * as Tools from "../../../helpers/Tools";
import { logUI } from '../../../api/andyliticsApi';
import moment from 'moment-timezone';
import { Modal, ModalBody } from 'reactstrap';
import * as FileSaver from 'file-saver';
import DataLoadingSpinner from '../../common/DataLoadingSpinner';

/**
 * Container component for the pharmacy page.
 * 
 */
class HRBenefits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            copays: { InNetwork: null, OutOfNetwork: null },
            shouldRetrieveData: true,
            longestFootnote: null,
            currentPlan: null,
            showLeftNavArrow: false,
            showRightNavArrow: false,
            initialized: false,
            document: null,
            modalVisible: false,
            downloadingDocument: false,
            documentsAvailable: false,
            benefitPlanId: null,
            inNetworkCopay: null,
            inNetworkTier2Copay: null,
            otherCopays: null,
            lineItems: null,
            NoData: false,
        };
        this.setCopayData = this.setCopayData.bind(this);
        //this.setCurrentPlan = this.setCurrentPlan.bind(this);
        this.scrollCopays = this.scrollCopays.bind(this);
        this.queueBenefitDocument = this.queueBenefitDocument.bind(this);
        this.getDocumentsList = this.getDocumentsList.bind(this);
        this.setDocumentsList = this.setDocumentsList.bind(this);
        this.copayListRef = React.createRef();
        this.redirectToAccresaPortal = this.redirectToAccresaPortal.bind(this);
        //this.memberUpdated = this.memberUpdated.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate(this.props);
        logUI("MBHWeb.UI.HRBenefitsPlan.ComponentDidMount", new Date(), Tools.getURLPath());
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', (e) => { this.scrollCopays(false, true) });
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', (e) => { this.scrollCopays(false, true) } );
        }
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;
        const today = new Date(); //get accumulators as of today


        if (this.props.benefitPlanDetail && this.props.benefitPlanDetail !== prevProps.benefitPlanDetail) {
            this.setState({ showMemberInfoLoader: false });
            if (this.props.benefitPlanDetail) {
                this.setState({ benefitPlanId: this.props.benefitPlanDetail.PlanDisplayName });

                let items = this.props.benefitPlanDetail.LineItems;
                if (items) {
                    var lineItems = items.reduce(function (rv, x) {
                        (rv[x['TierLevel']] = rv[x['TierLevel']] || []).push(x);
                        return rv;
                    }, {});
                    this.setState({ lineItems: lineItems });
                }
                else {
                    this.setState({ NoData: true });
                }
            }
            else {
                this.setState({ NoData: true });
            }
        }

        if (this.props.benefitPlanDetail && this.state.lineItems && this.copayListRef.current && !this.state.initialized) {
            this.scrollCopays(true);
            this.setState({ initialized: true });
        }

        if (this.props.benefitDocumentData && this.props.benefitDocumentData !== prevProps.benefitDocumentData) {
            this.downloadBenefitDocument();
        }

        if (this.props.benefitDocuments && this.props.benefitDocuments !== prevProps.benefitDocuments) {
            this.setDocumentsList();
        }


        if (this.props.error && this.props.error !== prevProps.error) {
            this.setState({ downloadingDocument: false });
        }

        if ((swhp || hpIdentity) && this.state.shouldRetrieveData && !isFetching) {
            let memId = this.props.swhp || this.props.hpIdentity.memberUserClaims.memberHccId;

            if (hpIdentity) {
                this.props.getIsMemberDPCFlag(memId);
            }
            this.setState({ shouldRetrieveData: false });
            this.props.getPlanDetail(memId);
            this.props.getServiceCategories(memId, today);
        }
    }



    scrollCopays(left, onResize = false) {
        if (this.copayListRef.current) {
            if (!onResize) {            
                let scrollAmount = this.copayListRef.current.clientWidth
                if (this.copayListRef.current.clientWidth <= 992) {
                    scrollAmount = scrollAmount * .80
                }
                if (left) {
                    this.copayListRef.current.scrollLeft -= scrollAmount;
                } else {
                    this.copayListRef.current.scrollLeft += scrollAmount;
                }
            }
            this.setState({
                showLeftNavArrow: this.copayListRef.current.scrollLeft > 0,
                showRightNavArrow: this.copayListRef.current.scrollLeft < (this.copayListRef.current.scrollWidth - this.copayListRef.current.clientWidth)
            })
        }
    }

    setCopayData(lineItems) {
        //if (!lineItems || lineItems.length <= 0) return;
        //let longestCopay;
        //let copayObject = { InNetwork: [], OutOfNetwork: [] };
        //lineItems.map(item => {
        //    if (item.SectionName === "Copays") {
        //        if (item.TierLevel === "In-Network") {
        //            copayObject.InNetwork.push(item);
        //        } else if (item.TierLevel === "Out-Of-Network") {
        //            copayObject.OutOfNetwork.push(item);
        //        }

        //        if (!longestCopay || item.Footnotes.length > longestCopay.Footnotes.length) {
        //            longestCopay = item;
        //        }
        //    }
        //});

        //let footnoteArray = "[" + longestCopay.Footnotes + "]";
        //footnoteArray = JSON.parse(footnoteArray);
        //this.setState({ copays: copayObject, longestFootnote: footnoteArray });
    }

    //memberUpdated(mem) {
    //    this.setState({
    //        currentMember: mem,
    //        showLoader: true
    //    }, () => {
    //        this.props.getPlan(this.state.currentMember);
    //    })
    //}

    getDocumentsList() {
        this.setState({ downloadingDocument: true });
        let memId = this.props.swhp || this.props.hpIdentity.memberUserClaims.memberHccId;
        this.props.getBenefitDocuments(this.state.benefitPlanId, memId);
        this.setState({ modalVisible: true });
    }

    setDocumentsList() {
        this.setState({ downloadingDocument: false });
        if (this.props.benefitDocuments && this.props.benefitDocuments.length > 0) {
            this.setState({ documentsAvailable: true });
        }
    }

    queueBenefitDocument(document) {
        this.setState({ document: document, downloadingDocument: true });
        this.props.getBenefitDocument(document.Title);
    }

    downloadBenefitDocument() {
        if (!this.props.benefitDocumentData) return;
        this.setState({ downloadingDocument: false });
        FileSaver.saveAs(this.props.benefitDocumentData, this.state.document.FileName);
    }

    redirectToAccresaPortal() {
        let accresaWindow = window.open("", "_blank");
        accresaWindow.location.replace("https://bswdirectprimarycare.accresa.com");
    }

    render() {
        return (
            <div className="container-fluid body-content hp hp-benefits-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div>
                            <Modal className="benefit-document-modal" isOpen={this.state.modalVisible} centered>
                                <ModalBody>
                                    <div className="icon-close modal-close" onClick={() => this.setState({ modalVisible: false })} />
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="modal-title">
                                                Select a Benefits Document to View
                                            </div>
                                            <div className="document-list">
                                                {this.props.benefitDocuments && !this.state.downloadingDocument && this.state.documentsAvailable
                                                    ?
                                                    this.props.benefitDocuments.map((document, i) => {
                                                        return (
                                                            <div key={`document-item-${i}`} className="document-list-item">
                                                                <div className="document-icon"></div>
                                                                <div className="link-text document-title" onClick={() => { this.queueBenefitDocument(document) }}>{document.DocumentTypeDescription} {document.Title}</div>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    this.state.downloadingDocument
                                                        ?
                                                        <div className="spinner">
                                                            <div className="bounce1" />
                                                            <div className="bounce2" />
                                                            <div className="bounce3" />
                                                        </div>
                                                        :
                                                        "No documents available"
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="hp-title maxWidth-content">
                            Plan Benefits
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12">
                        <div className="sub-header maxWidth-content">
                            <div className="row no-gutters align-items-mobile benefits-plan-title">
                                <div>
                                    <span className="bold-text sub-header-label">Plan Name: </span>
                                    {this.state.benefitPlanId ? <span id="benefits-plan-display-name">{this.state.benefitPlanId}</span> : ""}
                                </div>
                                <div className="push-right mobile-push-up">
                                    {this.state.benefitPlanId ? <div className="link-text sub-header-label documents-link" onClick={() => { this.getDocumentsList() }}><span className="icon-document" /> Benefits Documents</div> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.props.benefitPlanDetail ?
                    <>
                        <div className="row hp-copays">
                            <div className="col-12">
                                <div className="maxWidth-content">
                                    <div className={`copays-navigation ${Tools.isMobile() ? 'is-mobile' : ''}`}>
                                        {this.copayListRef.current ? <div onClick={() => { this.scrollCopays(true); }} className={`icon-arrow-rt copays-nav-arrow copays-nav-arrow-left ${this.state.showLeftNavArrow ? '' : 'hide-arrow'}`}></div> : ""}
                                        {this.copayListRef.current ? <div onClick={() => { this.scrollCopays(false); }} className={`icon-arrow-rt copays-nav-arrow ${this.state.showRightNavArrow ? '' : 'hide-arrow'}`}></div> : ""}
                                    </div>

                                    <div className="copays-title-container">
                                        <div className="semi-bold-text copays-title">Copays</div>
                                        <span className="icon-question info-hover">
                                            <div className="info-hover-content">A copayment (copay) is a fixed amount you pay either for a covered health service at time of visit, or for a medication included in your prescription drug plan.</div>
                                        </span>
                                    </div>
                                    <div ref={this.copayListRef} className={`row no-gutters copays-carousel-container  ${Tools.isMobile() ? 'is-mobile' : ''}`}>
                                        {this.state.lineItems &&
                                            Object.keys(this.state.lineItems).map((title, i) => {
                                                return (
                                                    <div key={`copay-card-${title}`} className={`card  ${Tools.isMobile() ? 'is-mobile' : ''}`}>
                                                        <div className="copay-benefit-title">
                                                            {title}
                                                        </div>
                                                        <div className="card-body">
                                                            {this.state.lineItems[title].map((value, i) => {
                                                                return (
                                                                    <div className="copay-detail">
                                                                        <div className="copay-label">{value.LineItemName}</div>
                                                                        <div className="push-right copay-value">{value.Amount}</div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.isMemberDPC ?
                            <div className="row">
                                <div className="benefits-sso">
                                    <div className="col-12">
                                        <div className="benefits-sso-label">
                                            To review or change your Primary Care Physician through Accresa, visit the Accresa portal.
                                                        </div>
                                        <div className="push-right benefits-sso-button">
                                            <input type="button" className="btn button" value="View" onClick={() => this.redirectToAccresaPortal()} />
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                            : ""
                        }
                        {(this.props.swhp || (this.props.hpIdentity && this.props.hpIdentity.roles.includes("ActiveMembers"))) ?
                            <div className="row benefits-sso-row">
                                <div className="col-12">
                                    <div className="benefits-sso maxWidth-content">
                                        <div className="benefits-sso-label">
                                            Please click here to view your Pharmacy Claims
                                     </div>
                                        <div className="push-right benefits-sso-button">
                                            <input type="button" className="btn button" value="View" onClick={() => this.props.ssoPharmacyBenefits()} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""
                            }
                        {
                            this.props.serviceCategories ?
                                <div className="row">
                                    <div className="col-12">
                                        <div className="benefits-eoc-container maxWidth-content">
                                            <div className="eoc-title-container">
                                                <div className="semi-bold-text eoc-title">Explanation of Coverage</div>
                                            </div>
                                            <div className="eoc-list-container">
                                                {this.props.serviceCategories.map((detail, i) => {
                                                    return (
                                                        <div key={`eoc-list-item-${i}`} id={`eoc-list-item-${i}`} className="eoc-item-container">
                                                            <div className="eoc-item-header" onClick={(e) => { document.getElementById(`eoc-list-detail-${i}`).classList.toggle("toggled") }}>
                                                                {detail.displayName}
                                                                <span className="icon-arrow-sm-down push-right eoc-expand-toggle" />
                                                            </div>
                                                            <div id={`eoc-list-detail-${i}`} className="eoc-item-details">
                                                                <div className="row no-gutters eoc-tiers">
                                                                    {detail.tiers.map((tier, j) => {
                                                                        return (
                                                                            <div className={`col eoc-tier tier-${j}`}>{tier}</div>
                                                                        )
                                                                    })}
                                                                </div>
                                                                {Object.keys(detail.values).map((title, i) => {
                                                                    return (
                                                                        <div key={`tier-values-card-${i}`} className="">
                                                                            <div className="eoc-line-item tier-list-item-title">
                                                                                {title.charAt(0).toUpperCase() + title.slice(1)}
                                                                            </div>
                                                                            <div className="eoc-line-item">
                                                                                {detail.values[title].map((value, i) => {
                                                                                    return (
                                                                                        <div className="col eoc-value tier-list-item-title">{value}</div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}



                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <div className="col-12">
                                        <DataLoadingSpinner />
                                    </div>
                                </div>
                        }
                    </>
                    :
                    this.state.NoData ? "" :
                        <div className="row">
                            <div className="col-12">
                                <DataLoadingSpinner />
                            </div>
                        </div>
                }
            </div >
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        benefitPlans: state.healthPlanServices.benefitPlans,
        benefitPlanDetail: state.healthPlanServices.planDetail,
        isMemberDPC: state.healthPlanServices.isMemberDPC,
        benefitDocuments: state.healthPlanServices.benefitDocuments,
        benefitDocumentData: state.healthPlanServices.benefitDocumentData,
        serviceCategories: state.healthPlanServices.serviceCategories,
        benefitError: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPlanDetail: (memId) => dispatch({ type: types.HP_GET_BENEFIT_PLAN_DETAIL_START, memId: memId }),
        getBenefitDocuments: (planId, memId) => dispatch({ type: types.HP_GET_BENEFIT_DOCUMENTS_START, planId: planId, memId: memId }),
        getBenefitDocument: (documentName) => dispatch({ type: types.HP_GET_BENEFIT_DOCUMENT_START, documentName: documentName }),
        getServiceCategories: (memberId, asOfDate) => dispatch({ type: types.HP_GET_SERVICE_CATEGORIES_START, memberId: memberId, asOfDate: asOfDate, includeAll: true }),
        ssoPharmacyBenefits: () => dispatch({ type: types.HP_SSO_PHARMACY_START }),
        getIsMemberDPCFlag: (memberId) => dispatch({ type: types.HP_GET_IS_MEMBER_DPC_START, memberId: memberId }),

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HRBenefits));
